import authorImg1 from '../assets/images/avatar/01.webp';
import authorImg2 from '../assets/images/avatar/02.webp';
import authorImg3 from '../assets/images/avatar/03.webp';
import authorImg4 from '../assets/images/avatar/04.webp';
import authorImg5 from '../assets/images/avatar/05.webp';
import authorImg6 from '../assets/images/avatar/06.webp';
import authorImg7 from '../assets/images/avatar/07.webp';
import authorImg8 from '../assets/images/avatar/08.webp';
import authorImg9 from '../assets/images/avatar/09.webp';
import authorImg10 from '../assets/images/avatar/10.webp';

const TestimonialList = [
  {
    id: 1,
    authorImg: authorImg1,
    authorName: 'Gozzby',
    authorPosition: 'Music',
    description:
      "We don't take ourselves too seriously, but seriously enough to ensure we're creating the best product and experience for our customers. I feel like Help Scout does the same.",
  },
  {
    id: 2,
    authorImg: authorImg2,
    authorName: 'Educatgenix',
    authorPosition: 'Education',
    description:
      "We don't take ourselves too seriously, but seriously enough to ensure we're creating the best product and experience for our customers. I feel like Help Scout does the same.",
  },
  {
    id: 3,
    authorImg: authorImg3,
    authorName: 'Petfluent',
    authorPosition: 'Pet Care',
    description:
      "We don't take ourselves too seriously, but seriously enough to ensure we're creating the best product and experience for our customers. I feel like Help Scout does the same.",
  },
  {
    id: 4,
    authorImg: authorImg4,
    authorName: 'Financeoont',
    authorPosition: 'Finance',
    description:
      "We don't take ourselves too seriously, but seriously enough to ensure we're creating the best product and experience for our customers. I feel like Help Scout does the same.",
  },
  {
    id: 5,
    authorImg: authorImg5,
    authorName: 'Mobifluent',
    authorPosition: 'Mobile',
    description:
      "We don't take ourselves too seriously, but seriously enough to ensure we're creating the best product and experience for our customers. I feel like Help Scout does the same.",
  },
  {
    id: 6,
    authorImg: authorImg6,
    authorName: 'Mobifluent',
    authorPosition: 'Mobile',
    description:
      "We don't take ourselves too seriously, but seriously enough to ensure we're creating the best product and experience for our customers. I feel like Help Scout does the same.",
  },
  {
    id: 7,
    authorImg: authorImg7,
    authorName: 'Mobifluent',
    authorPosition: 'Mobile',
    description:
      "We don't take ourselves too seriously, but seriously enough to ensure we're creating the best product and experience for our customers. I feel like Help Scout does the same.",
  },
  {
    id: 8,
    authorImg: authorImg8,
    authorName: 'Mobifluent',
    authorPosition: 'Mobile',
    description:
      "We don't take ourselves too seriously, but seriously enough to ensure we're creating the best product and experience for our customers. I feel like Help Scout does the same.",
  },
  {
    id: 9,
    authorImg: authorImg9,
    authorName: 'Mobifluent',
    authorPosition: 'Mobile',
    description:
      "We don't take ourselves too seriously, but seriously enough to ensure we're creating the best product and experience for our customers. I feel like Help Scout does the same.",
  },
  {
    id: 10,
    authorImg: authorImg10,
    authorName: 'Mobifluent',
    authorPosition: 'Mobile',
    description:
      "We don't take ourselves too seriously, but seriously enough to ensure we're creating the best product and experience for our customers. I feel like Help Scout does the same.",
  },
];

export default TestimonialList;
